import { useState } from 'react'

import { useCloseModal, useModalController, useConfigureModalController } from '@/atoms'

type ModalState = 'ready' | 'submitting'
interface ModalData {
  source: uui.domain.server.gps.telematics.Source
}

export const modalId = 'createTenantSource'

export const useController = () => useModalController<ModalData, ModalState>(modalId)
export const useConfigureController = (source: uui.domain.server.gps.telematics.Source) => {
  const close = useCloseModal()

  // INITIALIZATION

  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        source,
      },
    }),
  }))

  return useConfigureModalController<ModalData, ModalState>(modalId, options)
}
